/** Shared empty TipTap document helpers (no API imports — avoids circular deps). */

export const emptyTipTapDoc = () => ({
  type: 'doc',
  content: [{ type: 'paragraph' }],
});

export const emptyTipTapNotes = () => ({
  format: 'tiptap',
  doc: emptyTipTapDoc(),
});
